import * as React from 'react';
import PropTypes from 'prop-types';
import Svg, { Path } from 'react-native-svg';
import { colors } from '../constants';

const SvgOrder = ({ active, size }) => (
  <Svg height={size} viewBox="0 0 24 24" width={size}>
    <Path
      d="M5.513 10.42c-.746 0-1.386 0-1.706-.107-.427-.106-.534-.426-.747-1.386C3.06 4.34 9.46 3.7 11.7 3.7c4.8 0 8.533 1.92 8.533 5.76 0 .32-.106.533-.426.747 0 .106 0 .106-.107.106-.107.107-.107.107-.213.107-.213.107-.64.107-1.173.107-.61 0-1.39-.043-1.96-.075-.33-.018-.59-.032-.707-.032-1.067-.107-1.92-.107-2.56-.107-1.042 0-1.492.057-1.93.111-.413.052-.815.103-1.697.103-.747 0-1.813 0-3.52-.107h-.427zm15.574.853c-.32.214-.64.427-1.174.534-.068 0-.147.01-.255.025-.229.032-.585.081-1.238.081s-1.387-.04-1.955-.07c-.36-.02-.653-.036-.818-.036-.601 0-1.135-.034-1.6-.064-.36-.023-.68-.043-.96-.043-.96 0-1.28 0-1.707.107-.427.106-.853.106-1.92.106-.853 0-2.027 0-3.627-.106H4.767c-.747 0-1.707 0-2.347-.64-.213.426-.32.96-.32 1.6 0 2.453 2.987 2.453 4.587 2.453.875 0 1.566.037 2.14.067.405.021.75.04 1.06.04.95 0 1.432-.03 1.89-.057.416-.026.813-.05 1.523-.05.747 0 1.814 0 3.52.107h.64c1.067 0 2.56-.107 2.987-.427.853-.747 1.387-2.56.64-3.627zm-4.374 5.44c-1.493-.106-2.666-.106-3.413-.106H9.887c-.854 0-1.814 0-3.2-.107h-.214c-.746 0-2.133-.107-3.306-.533v.64c.106 1.28.96 2.133 1.92 2.666.96.427 1.92.427 2.88.427H15.54c1.067 0 2.133 0 3.2-.533.853-.534 1.6-1.6 1.707-2.88-.534.213-1.494.32-2.987.32-.32.106-.533.106-.747.106z"
      fill={active ? colors.itemActive : colors.itemInactive}
    />
  </Svg>
);

SvgOrder.defaultProps = {
  active: false,
  size: 26
};

SvgOrder.propTypes = {
  // optional
  active: PropTypes.bool,
  size: PropTypes.number
};

export default SvgOrder;
